import CookieUtil from "../storage/cookieUtil";
import { removeSessionStorage } from "../storage/sessionStorageUtil";
import {
  LAST_VISITED_ADDRESS,
  LAST_VISITED_PINCODE,
  SELECTED_SAVED_ADDRESS,
  SELECTED_SAVED_ADDRESS_USERNAME,
} from "../../constants/storage";
import { WHATSAPP_OTP_ATTEMPT_COUNT_KEY } from "../../constants/pageConstants/loginConstants";

/**
 * Clears client session state shared by header logout and account menu logout.
 */
export function clearAccountClientSession() {
  if (typeof window?.clearAndDestoryWidget === "function") {
    window?.clearAndDestoryWidget();
  }
  delete window.userDetails;

  document.cookie = "lgpopsh=false; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
  document.cookie = "uscnlg=false; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";

  const pathOptions = { path: "/" };
  const selectedSaveAddress = CookieUtil.getCookie(SELECTED_SAVED_ADDRESS);
  if (selectedSaveAddress) {
    CookieUtil.deleteCookie(SELECTED_SAVED_ADDRESS, pathOptions);
    CookieUtil.deleteCookie(SELECTED_SAVED_ADDRESS_USERNAME, pathOptions);
    CookieUtil.deleteCookie(LAST_VISITED_PINCODE, pathOptions);
    CookieUtil.deleteCookie(LAST_VISITED_ADDRESS, pathOptions);
  }

  sessionStorage.clear();
  removeSessionStorage(WHATSAPP_OTP_ATTEMPT_COUNT_KEY);
}
